// Months of the year for labeling charts
export const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

// Revenue data
export const revenueData = {
  total: "$107,843.82",
  membership: "$67,425.50",
  events: "$40,418.32",

  // Monthly revenue series for area chart
  membershipSeries: {
    name: "Membership Revenue",
    data: [320, 340, 330, 350, 380, 410, 430, 450, 470, 500, 530, 560],
    color: "#4F46E5",
  },
  eventsSeries: {
    name: "Event Revenue",
    data: [420, 410, 450, 480, 520, 590, 630, 610, 670, 720, 780, 850],
    color: "#EC4899",
  },
};

// Member analytics
export const memberData = {
  totalMembers: 187,
  activeMembers: 173,
  suspendedMembers: 6,
  cancelledMembers: 8,
  newMembersThisMonth: 14,
  memberRetentionRate: "92%",

  // Member breakdown by size
  memberBreakdown: [
    { name: "0-20", value: 47, color: "#3B82F6" },
    { name: "21-40", value: 38, color: "#10B981" },
    { name: "41-60", value: 31, color: "#F59E0B" },
    { name: "61-80", value: 29, color: "#8B5CF6" },
    { name: "81-100", value: 42, color: "#EF4444" },
  ],

  // New members by month
  newMembersMonthly: [
    {
      name: "New Members",
      data: [12, 15, 10, 18, 8, 14, 20, 16, 13, 19, 15, 11],
      color: "#3B82F6",
    },
    {
      name: "Renewals",
      data: [7, 9, 8, 11, 5, 10, 14, 12, 9, 13, 10, 8],
      color: "#F59E0B",
    },
  ],

  // Member engagement
  memberEngagement: {
    name: "Engagement",
    data: [55, 60, 65, 68, 70, 75, 78, 80, 77, 82, 85, 88],
    color: "#3B82F6",
  },

  // Member status breakdown for reports
  memberStatusBreakdown: [
    { name: "Active", value: 173, color: "#10B981" },
    { name: "Suspended", value: 6, color: "#F59E0B" },
    { name: "Cancelled", value: 8, color: "#EF4444" },
  ],
};

// Event analytics
export const eventData = {
  totalEvents: 35,
  upcomingEvents: 7,
  averageAttendance: 43,
  eventRevenue: "$38,650",

  // Event attendance by month
  attendanceSeries: [
    {
      name: "In-Person",
      data: [90, 110, 120, 125, 130, 145, 150, 140, 155, 160, 170, 175],
      color: "#4F46E5",
    },
    {
      name: "Virtual",
      data: [40, 45, 50, 55, 60, 65, 70, 65, 70, 75, 80, 85],
      color: "#EC4899",
    },
  ],

  // Event revenue by type
  eventsByType: [
    { name: "Networking", value: 12, color: "#3B82F6" },
    { name: "Workshops", value: 8, color: "#10B981" },
    { name: "Conferences", value: 2, color: "#F59E0B" },
    { name: "Fundraising", value: 5, color: "#8B5CF6" },
    { name: "Other", value: 8, color: "#EF4444" },
  ],

  // Ticket sales trend
  ticketSales: {
    name: "Tickets Sold",
    data: [120, 150, 160, 180, 190, 210, 220, 200, 230, 240, 250, 260],
    color: "#4F46E5",
  },
};

// Email analytics
export const emailData = {
  totalEmails: 45,
  openRate: "32%",
  clickThroughRate: "8.5%",
  averageResponseTime: "1.2 days",

  // Email engagement rates
  emailEngagement: {
    openRateSeries: {
      name: "Open Rate",
      data: [28, 30, 27, 32, 30, 33, 35, 32, 34, 36, 38, 37],
      color: "#3B82F6",
    },
    clickRateSeries: {
      name: "Click Rate",
      data: [6, 7, 6.5, 8, 7.5, 9, 9.5, 8.5, 9, 10, 10.5, 11],
      color: "#F59E0B",
    },
  },

  // Email types
  emailsByType: [
    { name: "Newsletters", value: 20, color: "#3B82F6" },
    { name: "Events", value: 12, color: "#10B981" },
    { name: "Announcements", value: 8, color: "#F59E0B" },
    { name: "Membership", value: 5, color: "#8B5CF6" },
  ],
};

// Invoicing analytics
export const invoicingData = {
  totalInvoiced: "$142,850",
  totalPaid: "$107,843.82",
  outstanding: "$35,006.18",
  overdue: "$12,450",

  // Payment status
  paymentStatus: [
    { name: "Paid", value: 107843.82, color: "#3B82F6" },
    { name: "Receivable", value: 22556.18, color: "#10B981" },
    { name: "30 Days Overdue", value: 12450, color: "#EF4444" },
  ],

  // Monthly invoicing
  monthlyInvoicing: [
    {
      name: "Invoiced",
      data: [
        10500, 11200, 12000, 11800, 12500, 13000, 12800, 11900, 12700, 13500,
        14200, 14950,
      ],
      color: "#4F46E5",
    },
    {
      name: "Collected",
      data: [
        9800, 10500, 11200, 10900, 11800, 12300, 12000, 11000, 11800, 12800,
        13500, 14200,
      ],
      color: "#EC4899",
    },
  ],

  // Overdue invoices by type
  overdueInvoicesByType: [
    { type: "Membership", count: 4, amount: 5800, color: "#EF4444" },
    { type: "Event Registration", count: 2, amount: 1850, color: "#F59E0B" },
    { type: "Event Sponsorship", count: 3, amount: 4800, color: "#8B5CF6" },
  ],

  // Overdue invoices detail
  overdueInvoices: [
    {
      member: "ABC Company",
      invoice: "INV-2023-042",
      dueDate: "Apr 15, 2023",
      amount: "$1,250.00",
      daysOverdue: 45,
      type: "Membership",
    },
    {
      member: "XYZ Corporation",
      invoice: "INV-2023-039",
      dueDate: "Apr 10, 2023",
      amount: "$2,350.00",
      daysOverdue: 50,
      type: "Membership",
    },
    {
      member: "Local Business LLC",
      invoice: "INV-2023-036",
      dueDate: "Mar 31, 2023",
      amount: "$750.00",
      daysOverdue: 60,
      type: "Event Registration",
    },
    {
      member: "123 Industries",
      invoice: "INV-2023-031",
      dueDate: "Mar 20, 2023",
      amount: "$3,400.00",
      daysOverdue: 71,
      type: "Event Sponsorship",
    },
    {
      member: "Main Street Shop",
      invoice: "INV-2023-028",
      dueDate: "Mar 15, 2023",
      amount: "$850.00",
      daysOverdue: 76,
      type: "Membership",
    },
  ],
};

// Website analytics
export const websiteData = {
  totalVisits: 21580,
  uniqueVisitors: 14360,
  averageSessionDuration: "3:42",
  bounceRate: "32%",

  // Traffic sources
  trafficSources: [
    { name: "Organic Search", value: 8632, color: "#3B82F6" },
    { name: "Direct", value: 5744, color: "#10B981" },
    { name: "Social", value: 4316, color: "#F59E0B" },
    { name: "Other", value: 2888, color: "#8B5CF6" },
  ],

  // Monthly visitor trend
  visitorTrend: {
    name: "Visitors",
    data: [
      1450, 1520, 1610, 1720, 1800, 1950, 2100, 2060, 2200, 2350, 2450, 2550,
    ],
    color: "#4F46E5",
  },

  // Page visits
  topPages: [
    { page: "Home", visits: 5430 },
    { page: "Events", visits: 3680 },
    { page: "Membership Directory", visits: 2940 },
    { page: "Membership Application", visits: 1870 },
    { page: "Chamber Staff", visits: 1220 },
  ],
};
